import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IDetailTripResponse } from 'src/app/interfaces/Responses/IDetailTripResponse';
import { Image } from '../../../../interfaces/Responses/IDetailTripResponse';
import { GeneralService } from '../../../../services/dashboards/general.service';

@Component({
  selector: 'neoris-trip-detail',
  templateUrl: './trip-detail.component.html',
  styleUrls: ['./trip-detail.component.css']
})
export class TripDetailComponent implements OnInit, OnDestroy {

  @Input() response: IDetailTripResponse
  @Input() images: Image[]
  @Input() anyImages: boolean

  @ViewChild('image') image: ElementRef
  @ViewChild('pagination') pagination: ElementRef
  allImages: Image[]
  editPlateForm: UntypedFormGroup
  currentIndexImage: number = 0
  editable: boolean = false

  tripID: string




  constructor(
    private builder: UntypedFormBuilder,
    private renderer: Renderer2,
    private generalService: GeneralService
  ) {
  }

  ngOnInit(): void {
    this.configForm()
  }

  configForm() {
    this.editPlateForm = this.builder.group({
      licensePlate: ['']
    })
  }

  ViewAllImages(e) {
    this.filterImages(e.target.value)
  }

  cwcChange(event: CustomEvent) {
    let data = JSON.parse(document.getElementById('id-trip').innerHTML)
    this.setImage(event.detail * 1 - 1, data.images)
  }

  setImage(arg0: number, images: Image[]) {
    if (arg0 !== undefined) this.currentIndexImage = arg0
 
    document.querySelectorAll('.image-page').forEach(element => {
      element.classList.remove('active')
    })
    document.querySelector(`#image-${this.currentIndexImage}`).classList.add('active')
    this.renderer.setAttribute(this.image.nativeElement, 'src', images[this.currentIndexImage].imagE_URL)
    this.renderer.setAttribute(this.image.nativeElement, 'alt', images[this.currentIndexImage].steP_NAME)
  }

  filterImages(checkPoint: string) {

    this.allImages = JSON.parse(document.getElementById('id-trip').innerHTML).images
    let filterImages = Array<any>()
    if (checkPoint === "0") {
      filterImages = this.allImages
    } else {
      filterImages = this.allImages.filter(i => i.checkpoinT_ID.toString() === checkPoint)
    }
    if (filterImages !== null && filterImages.length > 0) {
      this.anyImages = true
      this.images = filterImages
      setTimeout(() => {
        document.getElementById('facilityPoint').innerText = filterImages[0].chekpoinT_NAME
      }, 500);
      this.setImage(0, this.images)
    } else {
      this.anyImages = false
      this.images = []
    }
  }

  beEditable() {
    document.getElementById('licensePlate').removeAttribute('disabled')
    this.editable = true
  }

  beNotEditable() {
    let platenumber = document.getElementById('platenumber').innerHTML
    let inputValue = <HTMLInputElement>(document.getElementById('licensePlate'))
    inputValue.value = platenumber
    document.getElementById('licensePlate').setAttribute('disabled', 'true')
    this.editable = false
  }

  editPlate(values: any) {
    let licensePlate = values.licensePlate
    let tripid = document.getElementById('tripid').innerHTML
    this.generalService.updatePlateByTripID(tripid, licensePlate).subscribe((r) => {
      if (r.data) {
        document.getElementById('licensePlate').setAttribute('disabled', 'true')
        this.editable = false
        document.getElementById('update-lp').style.display = 'block'
        setTimeout(() => {
          document.getElementById('update-lp').style.display = 'none'
        }, 3000)
      }
    })
  }

  validate(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode >= 65 && charCode <= 90) return true
    if (charCode >= 97 && charCode <= 122) return true
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.currentIndexImage = 0
  }
}
